import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getAllComapniesList,
  getAllEmployeesListDataByCompanyId,
  getComapnyLeaveOverview,
  getLeaveTypes,
  updateLeaveStatus,
} from "../../../../services/attendanceService";
import { getErrorMessage } from "../utils/errorUtils";

import type { AdminLeavesFilters, LeaveStatus } from "./types";

export const fetchAdminLeaves = createAsyncThunk(
  "adminLeaves/fetchAdminLeaves",
  async (
    params: { companyId: number; companyType: string; filters: AdminLeavesFilters },
    { rejectWithValue },
  ) => {
    try {
      const { companyId, companyType, filters } = params;
      const res = await getComapnyLeaveOverview({
        companyId,
        companyType,
        page: filters.page,
        limit: filters.limit,
        search: filters.search?.trim() || undefined,
        employeeId: filters.employeeId ?? undefined,
        leaveTypeId: filters.leaveTypeId ?? undefined,
        status: filters.status ?? undefined,
        startDate: filters.startDate ?? undefined,
        endDate: filters.endDate ?? undefined,
      });
      return res?.data?.data ?? {};
    } catch (error: any) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const fetchAdminLeavesCompanies = createAsyncThunk(
  "adminLeaves/fetchCompanies",
  async (_: void, { rejectWithValue }) => {
    try {
      const res = await getAllComapniesList();
      return res?.data?.data?.data ?? [];
    } catch (error: any) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const fetchAdminLeavesEmployees = createAsyncThunk(
  "adminLeaves/fetchEmployees",
  async (
    params: { companyId: number; companyType: string },
    { rejectWithValue },
  ) => {
    try {
      const res = await getAllEmployeesListDataByCompanyId({
        company_id: params.companyId.toString(),
        company_type: params.companyType,
      });
      return res?.data?.data?.allUsers ?? [];
    } catch (error: any) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const fetchAdminLeaveTypes = createAsyncThunk(
  "adminLeaves/fetchLeaveTypes",
  async (
    params: { companyId: number; companyType: string },
    { rejectWithValue },
  ) => {
    try {
      const res = await getLeaveTypes({
        value: params.companyId.toString(),
        type: params.companyType,
      });
      return res?.data?.data?.leaveTypes ?? [];
    } catch (error: any) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const updateAdminLeaveStatus = createAsyncThunk(
  "adminLeaves/updateLeaveStatus",
  async (
    params: { leaveRequestId: number; status: LeaveStatus; rejectionReason?: string },
    { rejectWithValue },
  ) => {
    try {
      const res = await updateLeaveStatus(
        params.leaveRequestId,
        params.status,
        params.rejectionReason ?? null,
      );
      if (!res) return rejectWithValue("Unable to update leave status");
      return { leaveRequestId: params.leaveRequestId, status: params.status };
    } catch (error: any) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
